import React from 'react';
import { CallbackComponent } from 'redux-oidc';
import { useSelector } from 'react-redux';
import { UserPasswordlessManager } from 'shared/oidc/passwordLessUserManager';
import { useNavigate } from 'react-router-dom';
import { loadPasswordlessUser } from 'shared/redux/passwordlessOidcSlice';
import { ComponentLoader } from '@snsw/react-component-library';

export const LoginCallback = (props) => {
  const formData = useSelector((state) => state.form);
  const application = useSelector((state) => state.application);
  const { redirectTo } = formData;
  const navigate = useNavigate();
  return (
    <CallbackComponent
      userManager={UserPasswordlessManager.instance()}
      successCallback={() => {
        window.history.replaceState({}, window.document.title, window.location.origin + window.location.pathname);
        loadPasswordlessUser(props.store, UserPasswordlessManager.instance()).then(() => {
          if (redirectTo) {
            navigate(redirectTo, { replace: true });
          } else if (application?.currentPath) {
            navigate(application?.currentPath, { replace: true });
          }
        });
      }}
      errorCallback={(error) => {
        // TODO: Always get 'No matching state found in storage' here.
        console.error(error);
        // history.push('/design/');
      }}
    >
      <ComponentLoader fullPage />
    </CallbackComponent>
  );
};
